import type { AxiosResponse } from "axios";
import ApiService from "src/util/api.service";
import { ServicesUrlEndpoints } from "./servicesEndpointConstant";

export interface TachographSettingRecord {
  id: string | number | null;
  vehicleId: string | number;
  enabled: boolean;
  externalId: string | null;
}

export interface TachographSettingPayload {
  enabled: boolean;
}

const vehicleUrl = (route: string, vehicleId: string | number) =>
  route.replace("{vehicleId}", encodeURIComponent(String(vehicleId)));

export const getTachographSettingByVehicleId = (
  vehicleId: string | number
): Promise<AxiosResponse<{ response: TachographSettingRecord | null } | TachographSettingRecord>> =>
  ApiService.get(vehicleUrl(ServicesUrlEndpoints.TACHO_VEHICLE.GET_BY_VEHICLE, vehicleId));

export const saveTachographSetting = (
  vehicleId: string | number,
  payload: TachographSettingPayload
) => ApiService.post(vehicleUrl(ServicesUrlEndpoints.TACHO_VEHICLE.SAVE, vehicleId), payload);
